import API from '../../../services/api.svelte.js';
import { notificate } from '../../../services/notification.js';

export function search(config = {}) {
    return API.search("v2/phishing/", config);
}

export function searchCampaignResults(id, config = {}) {
    return API.search(`v2/phishing/${id}/results`, config);
}

export function findCampaignResult(campaign_id, result_id, config = {}) {
    return API.find(`v2/phishing/${campaign_id}/results`, result_id, config);
}

export function find(id, config = {}) {
    return API.find("v2/phishing", id);
}

export function save(data, files = [], config = {}) {
    return API.save("v2/phishing", data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                let toastConfig = {
                    data: data.name,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: apiData.name});
            return apiData;
        });
}

// Import campaign results - supports both file upload (multipart) and textarea paste
export function importCampaignResults(campaign_id, data = {}, files = [], config = {}) {
    let fileList = Array.isArray(files) ? files : (files ? [files] : []);

    if (fileList.length > 0) {
        return API.saveMultipart(`v2/phishing/${campaign_id}/import`, data, fileList, config, 'file')
            .then(async (response) => {
                if (!response.ok) {
                    let errors;
                    try {
                        errors = await response.json();
                    } catch {
                        errors = { detail: response.statusText };
                    }
                    throw errors;
                }
                return response.json();
            });
    } else {
        return API.save(`v2/phishing/${campaign_id}/import`, data, [], config)
            .then(async (response) => {
                if (!response.ok) {
                    let errors;
                    try {
                        errors = await response.json();
                    } catch {
                        errors = { detail: response.statusText };
                    }
                    throw errors;
                }
                return response.json();
            });
    }
}

// Get campaign report (HTML string response)
export function getReport(campaign_id, language = "es", config = {}) {
    return API.getFile(`v2/phishing/${campaign_id}/report?language=${language}`, config);
}

// Download report as HTML file
export async function downloadReportFile(campaign, language = "es") {
    const response = await getReport(campaign.id, language);
    if (!response || !response.ok) {
        throw new Error("Error downloading report");
    }
    const htmlContent = await response.text();
    const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const campaignName = (campaign.name || campaign.id).toString().replace(/[^a-zA-Z0-9_\-]/g, "_");
    link.href = url;
    link.download = `reporte_campana_${campaignName}_${language}.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
}

export function del(campaign, config = {}) {
    return API.del("v2/phishing", campaign.id, config)
        .then(async (response) => {
            if (!response.ok) {
                notificate('delete_error', "toast", {data: campaign.name});
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: campaign.name});
            return data;
        });
}

export default {
    search,
    find,
    save,
    del,
    importCampaignResults,
    getReport,
    downloadReportFile,
    searchCampaignResults,
    findCampaignResult
}
